(function () {
  'use strict';
  // Se carga en el layout (mayoristas) y en la sección de registro: una sola vez.
  if (window.__asmWholesaleLoaded) return;
  window.__asmWholesaleLoaded = true;

  var ASM_ADMIN_URL = 'https://asm-admin-production.up.railway.app';
  var TIER_LABELS   = { mayorista: 'Mayorista (-20%)', instalador: 'Instalador (-15%)', distribuidor: 'Distribuidor (-25%)' };

  /* ═══════════════════════════════════════════════════════════
     1. Registration Form
     Intenta enviar al ASM Admin (DB + Telegram). Si falla,
     cae a Shopify /contact como respaldo.
     ═══════════════════════════════════════════════════════════ */
  window.wsHandleDocSelect = function (input) {
    var box = input.closest('.ws-doc-upload');
    var nameEl = box ? box.querySelector('.ws-doc-upload__name') : null;
    var file = input.files && input.files[0];
    if (file && nameEl) nameEl.textContent = file.name;
    var st = document.getElementById(input.id + '-status');
    if (st) { st.style.display = 'none'; st.textContent = ''; }
    var fld = input.closest('.ws-form__field');
    if (fld) fld.classList.remove('has-error');
  };

  function wsUploadDoc(inputId) {
    var input = document.getElementById(inputId);
    if (!input || !input.files || !input.files[0]) return Promise.resolve('');
    var statusEl = document.getElementById(inputId + '-status');
    if (statusEl) { statusEl.style.display = 'block'; statusEl.style.color = '#aaa'; statusEl.textContent = 'Subiendo documento…'; }

    var fd = new FormData();
    fd.append('doc', input.files[0]);
    return fetch(ASM_ADMIN_URL + '/api/wholesale/upload-doc', { method: 'POST', body: fd })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        if (json.ok) {
          if (statusEl) { statusEl.style.color = '#4ADE80'; statusEl.textContent = 'Documento adjuntado ✓'; }
          return json.doc_filename;
        }
        if (statusEl) { statusEl.style.color = '#FCA5A5'; statusEl.textContent = 'No se pudo subir el documento.'; }
        return '';
      })
      .catch(function () {
        if (statusEl) { statusEl.style.display = 'block'; statusEl.style.color = '#FCA5A5'; statusEl.textContent = 'Error al subir el documento.'; }
        return '';
      });
  }

  /* NIT — dígito de verificación (algoritmo oficial Colombia) */
  function wsNitDV(base) {
    var w = [3, 7, 13, 17, 19, 23, 29, 37, 41, 43, 47, 53, 59, 67, 71];
    var s = String(base).replace(/\D/g, '');
    var sum = 0;
    for (var i = 0; i < s.length; i++) { sum += parseInt(s.charAt(s.length - 1 - i), 10) * w[i]; }
    var r = sum % 11;
    return r > 1 ? 11 - r : r;
  }
  function wsParseNit(val) {
    var cleaned = (val || '').replace(/[^0-9-]/g, ''), base, dv;
    if (cleaned.indexOf('-') > -1) { var p = cleaned.split('-'); base = p[0].replace(/\D/g, ''); dv = (p[1] || '').replace(/\D/g, ''); }
    else { var d = cleaned.replace(/\D/g, ''); base = d.slice(0, -1); dv = d.slice(-1); }
    return { base: base, dv: dv };
  }
  function wsNitIsValid(val) {
    var p = wsParseNit(val);
    if (!p.base || p.base.length < 5 || p.dv === '') return false;
    return wsNitDV(p.base) === parseInt(p.dv, 10);
  }

  var form = document.getElementById('ws-registration-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!wsValidateForm()) return;

      var submitBtn = document.getElementById('ws-submit');
      submitBtn.classList.add('is-loading');
      submitBtn.disabled = true;

      Promise.all([wsUploadDoc('ws-doc'), wsUploadDoc('ws-doc-camara')]).then(function (files) {
        var tierInput = form.querySelector('input[name="tier"]:checked');
        var docTypeInput = form.querySelector('input[name="tipo_documento"]:checked');
        var data = {
          first_name:       form.elements['first_name'].value.trim(),
          last_name:        form.elements['last_name'].value.trim(),
          email:            form.elements['email'].value.trim(),
          phone:            form.elements['phone'].value.trim(),
          company:          form.elements['company'].value.trim(),
          nombre_comercial: form.elements['nombre_comercial'] ? form.elements['nombre_comercial'].value.trim() : '',
          tipo_documento:   docTypeInput ? docTypeInput.value : 'nit',
          nit:              form.elements['nit'].value.trim(),
          city:             form.elements['city'].value.trim(),
          address:          form.elements['address'] ? form.elements['address'].value.trim() : '',
          vehicles:         form.elements['vehicles'].value.trim(),
          tier:             tierInput ? tierInput.value : '',
          monthly_volume:   form.elements['monthly_volume'] ? form.elements['monthly_volume'].value : '',
          how_found:        form.elements['how_found'] ? form.elements['how_found'].value : '',
          message:          form.elements['message'] ? form.elements['message'].value.trim() : '',
          customer_id:      document.getElementById('ws-customer-id') ? document.getElementById('ws-customer-id').value : '',
          shop:             document.getElementById('ws-shop') ? document.getElementById('ws-shop').value : '',
          doc_filename:     files[0] || '',
          camara_filename:  files[1] || ''
        };

        // Primary: POST to ASM Admin (saves to DB + Telegram notification)
        fetch(ASM_ADMIN_URL + '/api/wholesale/apply', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data)
        })
          .then(function (res) { return res.json(); })
          .then(function (json) {
            if (json.ok) {
              wsShowSuccess(data.email);
            } else {
              wsSubmitViaContact(data, submitBtn);
            }
          })
          .catch(function () {
            wsSubmitViaContact(data, submitBtn);
          });
      });
    });
  }

  function wsSubmitViaContact(data, submitBtn) {
    var body = [
      '=== SOLICITUD CUENTA MAYORISTA B2B ===',
      'Nombre: ' + data.first_name + ' ' + data.last_name,
      'Email: ' + data.email,
      'Teléfono: ' + data.phone,
      'Empresa: ' + data.company,
      'NIT: ' + data.nit,
      'Ciudad: ' + data.city,
      'Vehículos: ' + data.vehicles,
      'Tier: ' + (TIER_LABELS[data.tier] || data.tier),
      'Volumen: ' + (data.monthly_volume || 'No indicado'),
      '¿Cómo nos encontró?: ' + (data.how_found || 'No indicado'),
      'Mensaje: ' + (data.message || 'Ninguno'),
      'ID Cliente Shopify: ' + (data.customer_id || 'Sin cuenta'),
      '',
      'ACCIÓN: Shopify Admin > Clientes > buscar ' + data.email + ' > agregar tag: wholesale-' + data.tier
    ].join('\n');

    fetch('/contact#contact_form', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({
        'form_type':      'contact',
        'utf8':           '✓',
        'contact[email]': data.email,
        'contact[name]':  data.first_name + ' ' + data.last_name + ' — Solicitud Mayorista',
        'contact[body]':  body,
        'contact[phone]': data.phone
      }).toString()
    })
      .then(function (res) {
        if (res.ok || res.redirected) wsShowSuccess(data.email);
        else { wsShowFormError('Error al enviar. Intenta de nuevo.'); submitBtn.classList.remove('is-loading'); submitBtn.disabled = false; }
      })
      .catch(function () {
        wsShowSuccess(data.email); // Show success even if fetch throws (Shopify redirect)
      });
  }

  function wsShowSuccess(email) {
    var wrap = document.getElementById('ws-form-wrap');
    var successEl = document.getElementById('ws-success');
    if (wrap) wrap.style.display = 'none';
    if (successEl) successEl.classList.add('is-visible');
    var emailEl = document.getElementById('ws-success-email');
    if (emailEl) emailEl.textContent = email;
  }

  /* ═══════════════════════════════════════════════════════════
     2. Real-time validation
     ═══════════════════════════════════════════════════════════ */
  function wsValidateForm() {
    var valid = true;
    form.querySelectorAll('[required]').forEach(function (field) {
      var wrapper = field.closest('.ws-form__field');
      if (!wrapper) return;
      var isEmpty = field.type === 'checkbox' ? !field.checked : field.value.trim() === '';
      var isInvalidEmail = field.type === 'email' && field.value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(field.value);
      if (isEmpty || isInvalidEmail) {
        wrapper.classList.add('has-error');
        field.classList.add('is-invalid');
        valid = false;
      } else {
        wrapper.classList.remove('has-error');
        field.classList.remove('is-invalid');
      }
    });
    var tierChecked = form.querySelector('input[name="tier"]:checked');
    var tierField = document.getElementById('field-tier');
    if (!tierChecked && tierField) { tierField.style.display = 'block'; valid = false; }
    else if (tierField) { tierField.style.display = 'none'; }

    // NIT/cédula: sin validación de largo ni de dígito de verificación —
    // el DV es opcional y cada documento tiene un largo distinto.
    // El chequeo de DV existe solo como feedback informativo en vivo.

    // RUT obligatorio
    var rut = document.getElementById('ws-doc');
    var rutField = document.getElementById('field-doc');
    if (rut && (!rut.files || !rut.files[0])) {
      if (rutField) rutField.classList.add('has-error');
      valid = false;
    }
    return valid;
  }

  function wsShowFormError(msg) {
    var existing = form.querySelector('.ws-form__global-error');
    if (existing) existing.remove();
    var div = document.createElement('div');
    div.className = 'ws-form__global-error';
    div.style.cssText = 'padding:12px 16px;background:rgba(239,68,68,0.1);border:1px solid rgba(239,68,68,0.3);border-radius:6px;color:#FCA5A5;font-size:1.3rem;margin-bottom:16px;';
    div.textContent = msg;
    form.querySelector('.ws-form__actions').insertAdjacentElement('beforebegin', div);
    div.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  if (form) {
    form.addEventListener('input', function (e) {
      var field = e.target;
      var wrapper = field.closest('.ws-form__field');
      if (wrapper && field.value.trim() !== '') {
        wrapper.classList.remove('has-error');
        field.classList.remove('is-invalid');
      }
    });
    form.querySelectorAll('input[name="tier"]').forEach(function (input) {
      input.addEventListener('change', function () {
        var f = document.getElementById('field-tier');
        if (f) f.style.display = 'none';
      });
    });

    // NIT — feedback en vivo SOLO positivo: si el último dígito coincide
    // con el DV se confirma; si no, no se muestra nada (el DV es opcional
    // y no sabemos si el usuario lo incluyó).
    var nitInput = document.getElementById('ws-nit');
    var nitFb = document.getElementById('ws-nit-feedback');
    if (nitInput && nitFb) {
      nitInput.addEventListener('input', function () {
        nitFb.className = 'ws-nit-feedback';
        nitFb.textContent = '';
        var dt = form.querySelector('input[name="tipo_documento"]:checked');
        if (!dt || dt.value !== 'nit') return;
        var p = wsParseNit(nitInput.value);
        if (!p.base || p.base.length < 5 || p.dv === '') return;
        if (wsNitIsValid(nitInput.value)) {
          nitFb.className = 'ws-nit-feedback ok';
          nitFb.textContent = nitFb.dataset.ok || 'NIT válido ✓';
        }
      });
    }
  }

  /* ═══════════════════════════════════════════════════════════
     3. Draft Order Checkout (B2B precio exacto en checkout)
     Intercepta el checkout de clientes wholesale y crea un
     Draft Order via ASM Admin con los precios reales del tier.
     ═══════════════════════════════════════════════════════════ */
  var isWholesale = document.body.dataset.wsCustomer === 'true';
  var wsTier      = document.body.dataset.wsTier || '';

  if (isWholesale && wsTier) {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[name="checkout"], .cart__checkout-button, #checkout, [href="/checkout"]');
      if (!btn) return;
      if (window.location.pathname.indexOf('/checkout') !== -1) return;
      e.preventDefault();
      e.stopPropagation();
      wsCreateDraftOrder(btn);
    }, true);
  }

  function wsCreateDraftOrder(btn) {
    var orig = btn.textContent || btn.value || '';
    btn.disabled = true;
    if (btn.tagName === 'INPUT') btn.value = 'Preparando pedido B2B...';
    else btn.textContent = 'Preparando pedido B2B...';

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // App Proxy de Shopify → ASM Admin: firma la petición e identifica al cliente con sesión.
        // Nivel y precios los calcula el servidor; aquí solo viajan variantes y cantidades.
        return fetch('/apps/asm-b2b/draft-order', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: cart.items.map(function (i) {
            return { variant_id: i.variant_id, quantity: i.quantity };
          }) })
        });
      })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        if (json.invoice_url) {
          window.location.href = json.invoice_url;
        } else {
          wsCheckoutFallback(btn, orig);
        }
      })
      .catch(function () {
        wsCheckoutFallback(btn, orig);
      });
  }

  function wsCheckoutFallback(btn, orig) {
    btn.disabled = false;
    if (btn.tagName === 'INPUT') btn.value = orig;
    else btn.textContent = orig;
    // Antes se iba al checkout normal en silencio y el mayorista pagaba precio público.
    if (window.confirm('No pudimos aplicar tu precio mayorista en este momento.\n\n' +
                       'Aceptar: pagar ahora a precio normal.\nCancelar: quedarte en el carrito y escribirnos por WhatsApp.')) {
      window.location.href = '/checkout';
    }
  }

})();
